/* =================================================================
  NEW: 2026/02/27
  新コード
  ================================================================= */
/**
 * videoポスターを再生時に消す
 * -----------------------------------*/
// #video_poster
  const videoWrappers = document.querySelectorAll('.video-wrapper');

  videoWrappers.forEach(wrapper => {
    const video = wrapper.querySelector('.target-video');
    const poster = wrapper.querySelector('.responsive-poster img');

    // 動画が再生されたら、その親要素内にあるポスター画像を隠す
    video.addEventListener('play', () => {
      if (poster) {
        poster.classList.add('is-playing');
      }
    }, { once: true }); // 各動画につき1回だけ実行
  });
// #endvideo_poster

/**
 * NEW: サイドナビ監視
 * -----------------------------------*/
const SideStickyNav = {
  init() {
    const navLinks = document.querySelectorAll('.section-nav__link');
    const sections = document.querySelectorAll('.side-sticky__block');
    if (!navLinks.length || !sections.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // アクティブクラスの切り替え
          navLinks.forEach(link => link.classList.remove('is-active'));
          const targetLink = document.querySelector(`.section-nav__link[href="#${entry.target.id}"]`);
          if (targetLink) targetLink.classList.add('is-active');
        }
      });
    }, {
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    });

    sections.forEach(section => observer.observe(section));
  }
};

document.addEventListener('DOMContentLoaded', () => SideStickyNav.init());
document.addEventListener('shopify:section:load', () => SideStickyNav.init());


/**
 * 動画箸休め スクロールアニメーション
 * -----------------------------------*/
window.addEventListener('scroll', () => {
    const wrappers = document.querySelectorAll('.video-reveal-wrapper');

    wrappers.forEach(wrapper => {
        const video = wrapper.querySelector('.js-reveal-video');
        const blurLayer = wrapper.querySelector('.js-reveal-blur');
        const filter = wrapper.querySelector('.video-reveal-filter');
        const messageItem = wrapper.querySelector('.js-reveal-text-item');

        if (!video || !blurLayer || !filter) return;

        const rect = wrapper.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        let progress = -rect.top / (wrapper.offsetHeight - windowHeight);
        progress = Math.max(0, Math.min(1, progress));

        // --- 追加：暗くしたくない場合の処理 ---
        let displayProgress = progress;
        if (wrapper.classList.contains('no-darken')) {
            // 例：進捗0.8以降は暗くならないよう、0.8で止める
            // もしくは完全に暗くしたくないなら常に 0.5 などで固定も可能
            displayProgress = Math.min(0.8, progress); 
        }

        // CSS変数には調整済みの値を渡す
        wrapper.style.setProperty('--v-progress', displayProgress);
        // ------------------------------------

        if (messageItem) {
            const msgRect = messageItem.getBoundingClientRect();
            const startPoint = windowHeight * 0.7;
            const endPoint = windowHeight * 0.5;
            let mInProg = (startPoint - msgRect.top) / (startPoint - endPoint);
            let opacity = Math.max(0, Math.min(1, mInProg));
            
            messageItem.style.opacity = opacity;
            messageItem.style.transform = `translateZ(0) translateY(${opacity * 0.01}px)`;
        }
    });
}, { passive: true });


/**
 * 運営メンバー専用：スライドクリップ監視 (js-reveal-left)
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.js-reveal-left');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        // JSで計算したdelayを直接CSS変数に流し込む
        const delayValue = el.getAttribute('data-delay') || '0';
        el.style.setProperty('--reveal-delay', `${delayValue}s`);

        // リフレッシュを待ってからクラスを付与
        requestAnimationFrame(() => {
          el.classList.add('is-animated');
        });

        observer.unobserve(el);
      }
    });
  }, {
    rootMargin: '0px 0px -10% 0px',
    threshold: 0
  });

  elements.forEach(el => observer.observe(el));
});


/**
 * ブログ背景画像 遅延読み込み
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const lazyBackgrounds = document.querySelectorAll('.js-lazy-bg');

  if ('IntersectionObserver' in window) {
    let bgObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target;
          const bgUrl = target.dataset.bg;

          if (bgUrl) {
            // CSS変数 --hover-bg をJSから注入
            target.style.setProperty('--hover-bg', `url('${bgUrl}')`);
            // 一度読み込んだら監視を解除
            observer.unobserve(target);
          }
        }
      });
    }, {
      // 画面に入る300px手前で読み込み開始（UX向上のため）
      rootMargin: '0px 0px 300px 0px'
    });

    lazyBackgrounds.forEach((bg) => {
      bgObserver.observe(bg);
    });
  } else {
    // 古いブラウザ用のフォールバック：即座に全読み込み
    lazyBackgrounds.forEach((bg) => {
      const bgUrl = bg.dataset.bg;
      if (bgUrl) bg.style.setProperty('--hover-bg', `url('${bgUrl}')`);
    });
  }
});


/**
 * コミュニティページ DATA数字の動き
 -----------------------------------*/
$(function() {
  const countUp = (el) => {
    const $this = $(el);
    const target = parseFloat($this.attr('data-target'));
    const isDecimal = $this.attr('data-target').includes('.'); // 小数点があるか判定
    
    $({ count: 0 }).animate({ count: target }, {
      duration: 750, // 0.75秒かけてアニメーション
      easing: 'swing',
      step: function() {
        let displayValue;
        if (isDecimal) {
          displayValue = this.count.toFixed(1); // 小数点1位まで
        } else {
          displayValue = Math.floor(this.count).toLocaleString(); // 整数＋カンマ区切り
        }
        $this.text(displayValue);
      },
      complete: function() {
        // 最後に確実にターゲットの数値を表示
        $this.text(isDecimal ? target : target.toLocaleString());
      }
    });
  };

  // 画面に入ったら実行
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        $(entry.target).find('.community-data__number').each(function() {
          countUp(this);
        });
        observer.unobserve(entry.target); // 一度実行したら監視解除
      }
    });
  }, { threshold: 0.5 }); // 50%見えたら実行

  const targetSection = document.querySelector('.community-data');
  if (targetSection) observer.observe(targetSection);
});



/* =================================================================
   DEPRECATED: Old  (To be removed after)
   旧コード（移行完了後に削除予定）
   ================================================================= */
 
/**
 * ヘッダー 表示制御
 -----------------------------------*/
(function() {
  const updateHeader = () => {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    // --- 設定：トップと同じ挙動にしたいページの条件を追加 ---
    const isSpecialPage = 
      // document.body.classList.contains('template-collection')
      window.location.pathname.includes('/products/community') ||
      window.location.pathname.includes('/products/webcreationcourse');       // 例：特定の固定ページ

    // 1. ページ判定（トップページ、または上記で指定した特別なページか）
    const isTopBehavior = 
      document.body.classList.contains('template-index') || 
      window.location.pathname === '/' ||
      isSpecialPage;
    
    // 2. 下層ページ（スクロール制御しないページ）の場合
    if (!isTopBehavior) {
      headerWrapper.classList.add('is-active');
      // 下層ページではスクロール監視も不要なため、イベントを解除して終了
      window.removeEventListener('scroll', updateHeader);
      return;
    }

    // 3. トップおよび指定したページの場合のスクロール制御
    const targetSection = document.querySelector('.js-secondview');
    
    // ターゲットが存在しないページでもエラーにならないよう考慮
    if (!targetSection) {
      // もしターゲットがないページで常にアクティブにしたいなら add、
      // 常に透明から始めたいなら remove
      return; 
    }

    const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY;
    const currentScroll = window.scrollY;

    if (currentScroll >= targetPosition) {
      headerWrapper.classList.add('is-active');
    } else {
      headerWrapper.classList.remove('is-active');
    }
  };

  // 実行タイミングの制御
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeader);
  } else {
    updateHeader();
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateHeader);
})();

/**
 * ヘッダー メガメニュー 総合ホバーアクション
 -----------------------------------*/
document.querySelectorAll('.mega-menu').forEach(details => {
  const content = details.querySelector('.custom-mega-menu__content');
  const imgContainer = details.querySelector('.custom-mega-menu__image');
  const links = details.querySelectorAll('.custom-mega-menu__link');
  
  if (!content || !imgContainer) return;

  // タッチデバイスかどうかを判定
  const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

  let isclosing = false;

  // --- 1. 画像切り替え関数 ---
  function updateMegaMenuImage(nextIndex) {
    const currentIndex = parseInt(imgContainer.dataset.currentIndex || 0);
    if (nextIndex === currentIndex) return;

    const nextWrapper = imgContainer.querySelector(`[data-img-index="${nextIndex}"]`);
    const currentWrapper = imgContainer.querySelector('.is-active');

    if (!nextWrapper) return;

    nextWrapper.style.transition = 'none';
    if (nextIndex > currentIndex) {
      nextWrapper.style.clipPath = 'inset(100% 0 0 0)';
    } else {
      nextWrapper.style.clipPath = 'inset(0 0 100% 0)';
    }

    nextWrapper.offsetHeight;

    nextWrapper.style.transition = ''; 
    if (currentWrapper) {
      currentWrapper.classList.remove('is-active');
      if (nextIndex > currentIndex) {
        currentWrapper.style.clipPath = 'inset(0 0 100% 0)';
      } else {
        currentWrapper.style.clipPath = 'inset(100% 0 0 0)';
      }
    }

    nextWrapper.classList.add('is-active');
    nextWrapper.style.clipPath = 'inset(0 0 0 0)';
    imgContainer.dataset.currentIndex = nextIndex;
  }

  // --- 2. 各リンクへのイベント登録 ---
  links.forEach(link => {
    // PCのみホバーで画像切り替え
    link.addEventListener('mouseenter', function() {
      if (isTouchDevice) return; 
      const targetIndex = parseInt(this.dataset.index);
      updateMegaMenuImage(targetIndex);
    });
  });

  const listArea = details.querySelector('.custom-mega-menu__list');
  if (listArea) {
    listArea.addEventListener('mouseleave', () => {
      if (isTouchDevice) return;
      updateMegaMenuImage(0);
    });
  }

  // --- 3. メニュー全体の開閉制御 (PC/スマホ分岐) ---
  
  if (!isTouchDevice) {
    // 【PC版】ホバーで開閉
    details.addEventListener('mouseenter', () => {
      isclosing = false;
      updateMegaMenuImage(0);
      details.setAttribute('open', '');
      document.body.classList.add('mega-menu-open'); // オーバーレイ用クラス
      requestAnimationFrame(() => {
        content.classList.add('is-animated');
      });
    });

    details.addEventListener('mouseleave', () => {
      if (isclosing) return;
      isclosing = true;
      content.classList.remove('is-animated');
      document.body.classList.remove('mega-menu-open'); // オーバーレイ用クラス

      setTimeout(() => {
        if (isclosing) {
          details.removeAttribute('open');
          isclosing = false;
          imgContainer.dataset.currentIndex = 0;
        }
      }, 500);
    });
  } else {
    // 【スマホ版】タップ操作を妨げないよう、クラス付与のみ管理（toggleイベント等を利用）
    details.addEventListener('toggle', () => {
      if (details.open) {
        document.body.classList.add('mega-menu-open');
        updateMegaMenuImage(0); // スマホでも初期画像を表示
      } else {
        document.body.classList.remove('mega-menu-open');
      }
    });
  }
});


/**
 * ヘッダー ホバーでDAWN子メニュー表示
 -----------------------------------*/
// PCサイズのみホバーでdetailsを開閉させるスクリプト
if (window.innerWidth >= 990) {
  document.querySelectorAll('.header__inline-menu details').forEach((details) => {
    let leaveTimer;

    // マウスが入った時：タイマーをキャンセルして開く
    details.addEventListener('mouseenter', () => {
      clearTimeout(leaveTimer);
      details.setAttribute('open', '');
    });

    // マウスが離れた時：200ミリ秒待ってから閉じる
    details.addEventListener('mouseleave', () => {
      leaveTimer = setTimeout(() => {
        details.removeAttribute('open');
      }, 200); // 0.2秒の猶予
    });
  });
}

/**
 * メガメニューオーバーレイ
 -----------------------------------*/
document.querySelectorAll('.mega-menu').forEach(menu => {
  menu.addEventListener('toggle', (event) => {
    if (menu.open) {
      document.body.classList.add('mega-menu-open');
    } else {
      // 他に開いているメニューがないか確認
      const anyOpen = Array.from(document.querySelectorAll('.mega-menu')).some(m => m.open);
      if (!anyOpen) {
        document.body.classList.remove('mega-menu-open');
      }
    }
  });
});

// オーバーレイをクリックしたら閉じる設定
document.querySelector('.mega-menu-overlay')?.addEventListener('click', () => {
  document.querySelectorAll('.mega-menu[open]').forEach(menu => {
    menu.removeAttribute('open');
  });
  document.body.classList.remove('mega-menu-open');
});


/**
 * サイドバーレイアウト目次
 -----------------------------------*/
 document.addEventListener('DOMContentLoaded', () => {
  const navLinks = document.querySelectorAll('.sticky-nav__link');
  const sections = document.querySelectorAll('.sticky-layout__content-block');

  const options = {
    root: null,
    rootMargin: '-20% 0px -70% 0px', // 判定位置の調整
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 全てのアクティブクラスを削除
        navLinks.forEach(link => link.classList.remove('is-active'));
        
        // 現在のIDに一致するリンクに付与
        const activeLink = document.querySelector(`.sticky-nav__link[href="#${entry.target.id}"]`);
        if (activeLink) activeLink.classList.add('is-active');
      }
    });
  }, options);

  sections.forEach(section => observer.observe(section));
});

/**
 * サイドバーレイアウト目次（汎用）
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const navLinks = document.querySelectorAll('.side-nav__link');
  const sections = document.querySelectorAll('.course-blocks');

  // オプション設定：セクションが画面のどの位置に来たら反応するか
  const options = {
    root: null, // ビューポートを基準にする
    rootMargin: '-20% 0px -70% 0px', // 画面の上部20%〜下部70%の間に入ったら反応
    threshold: 0 // 少しでも入ったら実行
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 現在表示されているセクションのIDを取得
        const id = entry.target.getAttribute('id');
        
        // 全てのリンクから一度クラスを削除
        navLinks.forEach(link => {
          link.classList.remove('is-active');
          // href属性が現在のIDと一致するリンクにクラスを付与
          if (link.getAttribute('href') === `#${id}`) {
            link.classList.add('is-active');
          }
        });
      }
    });
  }, options);

  // 各セクションを監視対象に登録
  sections.forEach(section => {
    observer.observe(section);
  });
});



/**
 * スムーススクロール
 -----------------------------------*/


/**
 * 記事リンクコピー
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const copyBtn = document.querySelector('.js-copy-link');
  if (!copyBtn) return;

  copyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const url = copyBtn.dataset.shareUrl;

    navigator.clipboard.writeText(url).then(() => {
      copyBtn.classList.add('is-copied');
      setTimeout(() => copyBtn.classList.remove('is-copied'), 1500);
    });
  });
});


/**
 * YouTube動画（軽量版）
 * - ホバープレビュー：.js-hover-preview のみ（動画2〜6やcompanyのyoutube想定）
 * - スマホ(タッチ)はホバープレビュー無効
 * - モーダル再生：.js-video-trigger クリックで維持
 -----------------------------------*/
$(function() {
  const $modal = $('.js-video-modal');
  const $modalPlaceholder = $('.js-modal-video-placeholder');
  const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';

  const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
  let $activePreview = null;

  const stopPreview = ($wrapper) => {
    if (!$wrapper || !$wrapper.length) return;
    $wrapper.find('.js-video-preview').empty();
    $wrapper.removeClass('is-previewing');
  };

  // 1. ホバー処理 (変更なし)
  if (!isTouchDevice) {
    $(document)
      .on('mouseenter', '.js-hover-preview', function() {
        const $wrap = $(this);
        const videoId = $wrap.data('videoId');
        if (!videoId) return;
        if ($wrap.hasClass('is-previewing')) return;
        if ($activePreview && $activePreview[0] !== $wrap[0]) {
          stopPreview($activePreview);
        }
        $activePreview = $wrap;
        const $preview = $wrap.find('.js-video-preview');
        if ($preview.find('iframe').length) return;
        const src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&controls=0&modestbranding=1&loop=1&playlist=${videoId}&rel=0&playsinline=1`;
        $preview.html(`<iframe src="${src}" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture"></iframe>`);
        $wrap.addClass('is-previewing');
      })
      .on('mouseleave', '.js-hover-preview', function() {
        stopPreview($(this));
        if ($activePreview && $activePreview[0] === $(this)[0]) $activePreview = null;
      });
  }

  // 2. モーダルを開く処理（改善）
  $(document).on('click', '.js-video-trigger', function() {
    const videoId = $(this).data('videoId');
    if (!videoId) return;

    // 前回のクリック元を記憶（閉じるときに戻すため）
    window.lastFocusedElement = document.activeElement;

    if ($activePreview) {
      stopPreview($activePreview);
      $activePreview = null;
    }

    const src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`;
    $modalPlaceholder.html(`<iframe src="${src}" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`);

    $modal.addClass('is-open').attr('aria-hidden', 'false');
    $('body').css('overflow', 'hidden');

    // 開いた後、最初の要素（通常は閉じるボタン）にフォーカス
    setTimeout(() => {
      $modal.find('.js-modal-close').first().focus();
    }, 100);
  });

  // 3. モーダルを閉じる処理（改善）
  const closeVideoModal = () => {
    $modal.removeClass('is-open').attr('aria-hidden', 'true');
    setTimeout(function() {
      if (!$modal.hasClass('is-open')) {
        $modalPlaceholder.empty();
        $('body').css('overflow', '');
        // フォーカスを元の要素に戻す
        if (window.lastFocusedElement) window.lastFocusedElement.focus();
      }
    }, 400);
  };

  $(document).on('click', '.js-modal-close, .video-modal__overlay', closeVideoModal);

  // 4. キーボード制御（Escape & フォーカストラップ）
  $(document).on('keydown', function(e) {
    if (!$modal.hasClass('is-open')) return;

    // Escキー
    if (e.key === 'Escape') {
      closeVideoModal();
      return;
    }

    // Tabキー（フォーカストラップ）
    if (e.key === 'Tab') {
      const $focusables = $modal.find(focusableSelectors);
      const $first = $focusables.first();
      const $last = $focusables.last();

      if (e.shiftKey) { // Shift + Tab
        if (document.activeElement === $first[0]) {
          e.preventDefault();
          $last.focus();
        }
      } else { // Tab
        if (document.activeElement === $last[0]) {
          e.preventDefault();
          $first.focus();
        }
      }
    }
  });
});


 /**
 * YouTube（動画1だけ）：表示領域に入ったら生成して自動再生 / 外れたら停止
 * - 横スクロール(.js-scroll-container)をrootに指定
 -----------------------------------*/
(() => {
  const init = () => {
    const wraps = document.querySelectorAll('.js-yt-autoplay-wrapper');
    if (!wraps.length) return;

    // 1つだけ同時再生（念のため）
    let activeWrap = null;

    // 軽い改善：初回だけ preconnect
    let preconnected = false;
    const preconnectOnce = () => {
      if (preconnected) return;
      preconnected = true;

      const add = (href) => {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = href;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      };

      add('https://i.ytimg.com');
      add('https://www.youtube-nocookie.com');
    };

    const buildIframe = (videoId) => {
      const src =
        `https://www.youtube-nocookie.com/embed/${videoId}` +
        `?autoplay=1&mute=1&loop=1&playlist=${videoId}` +
        `&controls=0&modestbranding=1&rel=0&playsinline=1`;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.frameBorder = '0';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.loading = 'lazy';
      return iframe;
    };

    const start = (wrap) => {
      const videoId =
        wrap.getAttribute('data-video-id') ||
        wrap.closest('.js-yt-autoplay-item')?.getAttribute('data-video-id');

      if (!videoId) return;

      // 1つだけ再生
      if (activeWrap && activeWrap !== wrap) stop(activeWrap);
      activeWrap = wrap;

      const preview = wrap.querySelector('.js-video-preview');
      if (!preview) return;
      if (preview.querySelector('iframe')) return;

      preconnectOnce();
      preview.appendChild(buildIframe(videoId));
      wrap.classList.add('is-previewing');
    };

    const stop = (wrap) => {
      const preview = wrap.querySelector('.js-video-preview');
      if (!preview) return;
      preview.innerHTML = ''; // iframe削除＝完全停止
      wrap.classList.remove('is-previewing');

      if (activeWrap === wrap) activeWrap = null;
    };

    wraps.forEach((wrap) => {
      // スライダー内なのでrootを横スクロール親に
      const root = wrap.closest('.js-scroll-container') || null;

      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) start(entry.target);
          else stop(entry.target);
        });
      }, {
        root,
        threshold: 0.6, // 60%見えたら再生
      });

      io.observe(wrap);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();




/**
 * ショート動画自動プレビュー
 -----------------------------------*/
$(function() {
  $('.js-file-preview-container').hover(
    function() {
      const $video = $(this).find('video');
      const video = $video.get(0);
      
      if (video) {
        // 1. ソースの流し込み（共通スクリプトの ensureSources と同様の処理）
        if (!video.dataset.loaded) {
          const vds = $video.attr('data-src');
          if (vds && !$video.attr('src')) {
            $video.attr('src', vds);
          }
          // sourceタグがある場合も考慮
          $video.find('source').each(function() {
            const ds = $(this).attr('data-src');
            if (ds && !$(this).attr('src')) $(this).attr('src', ds);
          });

          video.load();
          video.dataset.loaded = '1'; // ロード済みフラグを立てる
        }
        
        // 2. 再生
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log("Playback prevented: ", error);
          });
        }
      }
    },
    function() {
      const video = $(this).find('video').get(0);
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }
  );
});


/**
 * Lexa制作実績 ポップアップ（モーダル）複数対応版
 -----------------------------------*/
/**
 * Lexa制作実績 ポップアップ（モーダル）複数対応版
 * 【2026/03/04 修正】モーダル開閉と連動した待機アニメーション機能を追加
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const openBtns = document.querySelectorAll('.js-open-modal');
  const body = document.body;
  const modals = document.querySelectorAll('.modal-root');
  const closeBtns = document.querySelectorAll('.js-works-modal-close');

  // フォーカス可能な要素のリスト
  const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  /**
   * 1. モーダル内の待機アニメーションを開始する関数
   */
  const startModalWaitAnimations = (modal) => {
    const waitElements = modal.querySelectorAll('.js-modal-wait-reveal');
    waitElements.forEach(el => {
      // data-delay属性から秒数を取得（デフォルト0）、ミリ秒に変換
      const delay = parseFloat(el.getAttribute('data-delay') || 0) * 1000;
      
      setTimeout(() => {
        el.classList.add('is-revealed');
      }, delay);
    });
  };

  /**
   * 2. モーダル内のアニメーション状態をリセットする関数
   * 次に開いた時に再度アニメーションを実行させるためにクラスを外す
   */
  const resetModalWaitAnimations = (modal) => {
    const waitElements = modal.querySelectorAll('.js-modal-wait-reveal');
    waitElements.forEach(el => {
      el.classList.remove('is-revealed');
    });
  };

  /**
   * 3. モーダルを開く処理
   */
  openBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      // currentTargetを使用してクリックされた要素を確実に特定
      const targetId = e.currentTarget.getAttribute('data-target');
      const targetModal = document.getElementById(targetId);

      if (targetModal) {
        // 表示フラグの付与
        targetModal.classList.add('is-open');
        targetModal.setAttribute('aria-hidden', 'false');
        body.classList.add('is-modal-open');
        
        // モーダル内のスクロール位置をトップに戻す
        const container = targetModal.querySelector('.modal-container');
        if(container) container.scrollTop = 0;

        // 【新機能】待機アニメーションの発火
        startModalWaitAnimations(targetModal);

        // 最初の要素（通常は閉じるボタン）にフォーカスを当てる
        const firstFocusable = targetModal.querySelector(focusableSelectors);
        if (firstFocusable) {
          setTimeout(() => firstFocusable.focus(), 100);
        }
      }
    });
  });

  /**
   * 4. モーダルを閉じる処理
   */
  const closeModal = () => {
    modals.forEach(m => {
      if (m.classList.contains('is-open')) {
        // 【新機能】閉じるときにアニメーション状態をリセット
        resetModalWaitAnimations(m);
        m.classList.remove('is-open');
        m.setAttribute('aria-hidden', 'true');
      }
    });
    body.classList.remove('is-modal-open');
  };

  // 閉じるボタン（オーバーレイ含む）へのイベント登録
  closeBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      closeModal();
    });
  });
  
  /**
   * 5. キーボード操作（Escape & フォーカストラップ）
   */
  document.addEventListener('keydown', (e) => {
    // Escapeキーで閉じる
    if (e.key === 'Escape') {
      closeModal();
      return;
    }

    // Tabキーによるフォーカストラップ
    if (e.key === 'Tab') {
      const openModal = document.querySelector('.modal-root.is-open');
      if (!openModal) return;

      const focusables = openModal.querySelectorAll(focusableSelectors);
      if (focusables.length === 0) return;

      const firstFocusable = focusables[0];
      const lastFocusable = focusables[focusables.length - 1];

      if (e.shiftKey) { // Shift + Tab (逆送り)
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else { // Tab (正送り)
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
  });
});


/**
 * メッセージ セクション：出現 ➔ 暗転 ➔ テキスト ➔ 終盤でフェードアウト
 -----------------------------------*/
window.addEventListener('scroll', () => {
    const section = document.getElementById('sticky-section');
    if (!section) return;

    // --- 設定値の出し分け ---
    // slow-fadeクラスがある場合は、各フェーズの閾値を広げて「ゆっくり」にする
    const isSlow = section.classList.contains('is-slow-fade');
    
    const config = isSlow ? {
        revealEnd: 0.2,      // 動画フェード完了地点 (通常0.2 → 0.4に倍増)
        overlayStart: 0.2,   // オーバーレイ開始地点 (通常0.15 → 0.3)
        overlayEnd: 0.7,     // オーバーレイ完了地点 (通常0.4 → 0.7)
        textStart: 0.45,     // テキスト開始地点 (通常0.25 → 0.45)
        fadeOutStart: 0.75   // 最終フェードアウト開始 (通常0.9 → 0.85)
    } : {
        revealEnd: 0.2,
        overlayStart: 0.15,
        overlayEnd: 0.4,
        textStart: 0.25,
        fadeOutStart: 0.9
    };

    const videoWrap = document.getElementById('video-reveal-wrap');
    const overlay = document.getElementById('overlay');
    const textWrapper = document.getElementById('text-wrapper');
    const container = section.querySelector('.sticky-scroll__container');

    const rect = section.getBoundingClientRect();
    const sectionHeight = section.offsetHeight;
    const viewportHeight = window.innerHeight;

    let progress = -rect.top / (sectionHeight - viewportHeight);
    progress = Math.max(0, Math.min(1, progress));

    // --- 1. 動画の出現 ---
    const revealProgress = Math.max(0, Math.min(1, progress / config.revealEnd)); 
    videoWrap.style.opacity = revealProgress;
    videoWrap.style.filter = `blur(${(1 - revealProgress) * 20}px)`;

    // --- 2. オーバーレイ ---
    const overlayRange = config.overlayEnd - config.overlayStart;
    const overlayProgress = Math.max(0, Math.min(1, (progress - config.overlayStart) / overlayRange));
    overlay.style.opacity = overlayProgress * 0.7;

    // --- 3. テキストの表示とスライド ---
    if (progress > config.textStart) {
        const textProgress = (progress - config.textStart) / (1 - config.textStart);
        textWrapper.style.opacity = Math.min(1, textProgress * 95);

        const scrollDistance = viewportHeight + textWrapper.offsetHeight + 200; 
        textWrapper.style.top = `${viewportHeight - (textProgress * scrollDistance)}px`;
    } else {
        textWrapper.style.opacity = 0;
        textWrapper.style.top = `100%`;
    }

    // --- 4. フェードアウト ---
    // if (progress > config.fadeOutStart) {
    //     const fadeOutProgress = (progress - config.fadeOutStart) / (1 - config.fadeOutStart);
    //     container.style.opacity = 1 - fadeOutProgress;
    // } else {
    //     container.style.opacity = 1;
    // }
});



/**
 * 前後リンク：ホバー動画再生制御
 -----------------------------------*/
const initNavHoverVideo = () => {
  const containers = document.querySelectorAll('.js-nav-hover-video');

  containers.forEach(container => {
    const webm = container.getAttribute('data-video-webm');
    const mp4 = container.getAttribute('data-video-mp4');
    
    // 動画データがない場合は何もしない
    if (!webm && !mp4) return;

    // ビデオ要素の生成と初期設定
    const video = document.createElement('video');
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.setAttribute('preload', 'metadata');
    
    if (webm) { const s = document.createElement('source'); s.src = webm; s.type = "video/webm"; video.appendChild(s); }
    if (mp4) { const s = document.createElement('source'); s.src = mp4; s.type = "video/mp4"; video.appendChild(s); }
    
    container.appendChild(video);

    // リンク全体（aタグ）のホバーを監視
    const link = container.closest('.article-navigation__link');
    
    link.addEventListener('mouseenter', () => {
      container.classList.add('is-hovered');
      video.play().catch(e => console.log("Playback blocked:", e));
    });

    link.addEventListener('mouseleave', () => {
      container.classList.remove('is-hovered');
      video.pause();
      video.currentTime = 0; // 停止時に先頭に戻す
    });
  });
};

// 既存のDOMContentLoaded内、または末尾に追記
document.addEventListener('DOMContentLoaded', initNavHoverVideo);


 
/* ここから下はアニメーション検証エリア
 -------------------------------------------------------------------*/
 /**
 * ファーストビューアニメーション
 -----------------------------------*/
/**
 * 1. 文字分割の準備（BaseとActiveの両方を対象にする）
 */
function prepareCharAnim(selector) {
  const targets = document.querySelectorAll(selector);
  targets.forEach(target => {
    const text = target.textContent.trim();
    // 1文字ずつバラバラにする（BaseもActiveも同じロジックを通す）
    target.innerHTML = text.split('').map((char, i) => 
      `<span class="char" style="--char-index: ${i}">${char === ' ' ? '&nbsp;' : char}</span>`
    ).join('');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // .fv_copy-main という共通クラス、もしくは個別のクラスを指定
  // これで Base と Active 両方の文字が全く同じ span 構造になります
  prepareCharAnim('.loading-text-base, .loading-text-active, .fv__copy-sub.js-char-anim');
});

/**
 * 2. アニメーション発火
 */
window.addEventListener('loading-complete', () => {
  const header = document.querySelector('.header-wrapper');
  
  const specialPaths = [
    '/products/webcreationcourse',
    '/products/community'
  ];

  // 現在のパスがいずれかに含まれているか判定
  const isSpecialPage = specialPaths.includes(window.location.pathname);
  const isTopBehavior = 
    document.body.classList.contains('template-index') || 
    window.location.pathname === '/' ||
    isSpecialPage;

  if (!header) return;

  // --- 【修正】「トップと同じ挙動をさせない」本当の下層ページの場合のみ、即座に付与 ---
  if (!isTopBehavior) {
    header.classList.add('is-active', 'is-header-frame-active', 'is-logo-active');
    const container = document.querySelector('.loading-text-container');
    if (container) container.style.display = 'none';
    return;
  }

  // --- 以下、トップページ（および指定した商品ページ）用の演出ロジック ---
  const container = document.querySelector('.loading-text-container');
  if (container) {
    container.style.zIndex = '2';
  }

  // サブコピーをパラパラ出す
  setTimeout(() => {
    document.body.classList.add('is-sub-active');
  }, 100);

  const scroll = document.querySelector('.fv__scroll');
  
  // 1. まずフレームを表示
  setTimeout(() => {
    header.classList.add('is-header-frame-active');
    
    // 2. そのわずか後にロゴとスクロールを表示
    setTimeout(() => {
      header.classList.add('is-logo-active');
      if (scroll) scroll.classList.add('is-scroll-active');
      
      // 注意：ここで .is-active は付けない（スクロール制御側に任せるため）
    }, 650);
    
  }, 700);
});


/**
 * ブリッジセクション吹き出しアニメーション（一つ目）
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
        root: null,
        threshold: 0.6 // 100%見えたら実行
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                // 一度発火したら監視を止める場合
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // ターゲットを監視
    const target = document.querySelector('.bridge-image01');
    if (target) observer.observe(target);
});

/**
 * ブリッジセクション吹き出しアニメーション（二つ目）
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
        root: null,
        threshold: 0.6 // 100%見えたら実行
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                // 一度発火したら監視を止める場合
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // ターゲットを監視
    const target = document.querySelector('.bridge-image02');
    if (target) observer.observe(target);
});

/**
 * フッターCTA吹き出しアニメーション
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
        root: null,
        // CTAが大きい場合、0.6だと発火しにくいので0.2〜0.3程度がスムーズです
        threshold: 0.2 
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 交差した（画面に入った）要素にだけクラスを付与
                entry.target.classList.add('is-visible');
                // 一度表示されたら監視を解除して負荷を減らす
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // querySelectorAll でページ内の全ターゲットを取得
    const targets = document.querySelectorAll('.footer-cta__image');
    
    // 見つかったすべての要素に対して監視を開始
    targets.forEach(target => {
        observer.observe(target);
    });
});


/**
 * Lexaギャラリー
 -----------------------------------*/
const galleryObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll('.rich-gallery__image');
            
            items.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.add('is-visible');
                }, index * 50); // 50ms（0.05秒）間隔で次が動く
            });

            galleryObserver.unobserve(entry.target);
        }
    });
}, { threshold: 0.3 });

// 親要素を監視
const targetGallery = document.querySelector('.rich-gallery');
if (targetGallery) {
    galleryObserver.observe(targetGallery);
}

/**
 * ギャラリー画像アニメーション
 * 使い方：親要素に [data-stagger-group]、子要素に [data-stagger-item] を付与
 -----------------------------------*/
const staggerObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            // 親要素から設定を取得（delayが未設定ならデフォルト100ms）
            const delay = parseInt(entry.target.dataset.staggerDelay) || 100;
            const items = entry.target.querySelectorAll('[data-stagger-item]');
            
            items.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.add('is-visible');
                }, index * delay);
            });

            staggerObserver.unobserve(entry.target);
        }
    });
}, { threshold: 0.15 });

// ページ内の全グループを監視
document.querySelectorAll('[data-stagger-group]').forEach(group => {
    staggerObserver.observe(group);
});

/**
 * TOP 各コース紹介
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    const motionSections = document.querySelectorAll('.js-motion-section');

    function updateMotion() {
        const windowHeight = window.innerHeight;

        motionSections.forEach(section => {
            const rect = section.getBoundingClientRect();
            const frame = section.querySelector('.motion-frame');
            
            // アニメーションを開始するオフセット値（画面の下から何pxで開始するか）
            const startOffset = windowHeight * 0.7; 
            
            // 分母を startOffset だけにすることで、rect.top が 0（画面上端）に
            // 到達した瞬間に progress が 1.0 になるように計算します。
            let progress = (startOffset - rect.top) / startOffset;
            
            // 0〜1の範囲に固定。これにより rect.top がマイナス（sticky状態）になっても
            // 1.0 のまま保持され、アニメーションが停止した状態になります。
            progress = Math.max(0, Math.min(1, progress));

            // CSS変数 --scroll-progress を更新
            frame.style.setProperty('--scroll-progress', progress.toFixed(4));
        });

        requestAnimationFrame(updateMotion);
    }

    updateMotion();
});


/**
 * ヘッダーホバーアクション（黄色いドット用）
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // header-menu または <li> を基準に、メニュー全体を監視
  const menuWrappers = document.querySelectorAll('header-menu, .header__inline-menu > ul > li');
  const DURATION = 200; 

  menuWrappers.forEach(wrapper => {
    const link = wrapper.querySelector('.header__menu-item');
    if (!link) return;

    const details = wrapper.querySelector('details');
    let isHovering = false;
    let isTransitioning = false;

    // 状態をチェックする関数（ホバー中、またはdetailsがopenなら「アクティブ」）
    const isActive = () => isHovering || (details && details.hasAttribute('open'));

    const startAnimation = () => {
      if (isTransitioning) return;
      link.classList.remove('is-leaving');
      link.classList.add('is-animated');
      isTransitioning = true;

      setTimeout(() => {
        isTransitioning = false;
        if (!isActive()) leave();
      }, DURATION);
    };

    const leave = () => {
      link.classList.remove('is-animated');
      link.classList.add('is-leaving');
      setTimeout(() => {
        if (!isActive()) link.classList.remove('is-leaving');
      }, DURATION);
    };

    // 親要素全体でのホバー監視
    wrapper.addEventListener('mouseenter', () => {
      isHovering = true;
      startAnimation();
    });

    wrapper.addEventListener('mouseleave', () => {
      isHovering = false;
      // detailsがない、または閉じている場合のみ即座にleave判定
      if (!details || !details.hasAttribute('open')) {
        if (!isTransitioning) leave();
      }
    });

    // detailsの開閉（Click/Focus）を監視
    if (details) {
      // 属性の変化を監視（MutationObserver）して、閉じられた瞬間にleaveを発火
      const observer = new MutationObserver(() => {
        if (!details.hasAttribute('open') && !isHovering) {
          if (!isTransitioning) leave();
        }
      });
      observer.observe(details, { attributes: true, attributeFilter: ['open'] });
    }
  });
});

/**
 * フッターホバーアクション
 -----------------------------------*/
document.querySelectorAll('.footer-block__lists li a, .footer-menu-home').forEach(link => {
    if (!link.querySelector('.inner-text')) {
        const text = link.textContent.trim();
        
        // 1文字ずつ分解。transition-delayはCSSのホバー時のみ適用されるようJSで付与
        const characters = [...text].map((char, i) => {
            const content = char === ' ' ? '&nbsp;' : char;
            return `<span style="--delay: ${i * 0.03}s">${content}</span>`;
        }).join('');

        link.innerHTML = `
            <span class="inner-text">
                <span class="original-text">${text}</span>
                <span class="hover-text">${characters}</span>
            </span>`;
    }

    let isHovering = false;
    let isTransitioning = false;
    const duration = 200; 

    link.addEventListener('mouseenter', () => {
        isHovering = true;
        if (isTransitioning) return;

        link.classList.remove('is-leaving');
        link.classList.add('is-animated');
        isTransitioning = true;

        setTimeout(() => {
            isTransitioning = false;
            if (!isHovering) leave();
        }, duration);
    });

    link.addEventListener('mouseleave', () => {
        isHovering = false;
        if (!isTransitioning) leave();
    });

    function leave() {
        link.classList.remove('is-animated');
        link.classList.add('is-leaving');
        setTimeout(() => {
            if (!isHovering) link.classList.remove('is-leaving');
        }, duration);
    }
});

/**
 * TOPアニメーション見出し
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    let isPageLoaded = false; // ローディング完了フラグ

    // ポリシーページのコンテナを探し、アニメーション用属性を強制付与
    const policyContainer = document.querySelector('.shopify-policy__container');
    if (policyContainer) {
        policyContainer.classList.add('js-fade-in');
        policyContainer.setAttribute('data-wait-loading', ''); // タイトルの後に出したい場合
        policyContainer.setAttribute('data-delay', '0.5');    // 必要に応じて遅延秒数を調整
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const target = entry.target;

                // 発火処理を行う関数
                const activateElement = (el) => {
                    // data-wait-loadingがあり、まだロード未完了ならスキップ
                    if (el.hasAttribute('data-wait-loading') && !isPageLoaded) return;

                    // data-delay属性があればCSS変数 --delay にセット
                    if (el.dataset.delay) {
                        el.style.setProperty('--delay', `${el.dataset.delay}s`);
                    }
                    el.classList.add('is-show');
                    
                    // 個別に監視されていた場合の解除
                    observer.unobserve(el);
                };

                // A. グループ指定がある場合
                if (target.classList.contains('js-scroll-trigger-group')) {
                    const children = target.querySelectorAll('.js-fade-in, .js-scroll-trigger');
                    
                    // グループ自体に待機属性があるか、子要素にあるかを確認して実行
                    children.forEach(child => activateElement(child));
                    
                    // 全ての子要素が発火対象（または待機中）になったら親の監視は終了
                    observer.unobserve(target);
                } 
                // B. 通常の単体発火
                else {
                    activateElement(target);
                }
            }
        });
    }, {
        root: null,
        rootMargin: '0px 0px -15% 0px',
        threshold: 0
    });

    // 監視対象：単体要素 + グループ親要素
    const triggerElements = document.querySelectorAll('.js-scroll-trigger, .js-fade-in, .js-scroll-trigger-group');
    triggerElements.forEach(el => observer.observe(el));

    // --- ロード完了イベント制御 ---
    window.addEventListener('loading-complete', () => {
        isPageLoaded = true;

        // すでに表示領域内（IntersectionObserverで検知済み）だが、
        // ロード待ちで止まっていた要素を一斉にチェック
        const pendingElements = document.querySelectorAll('.js-scroll-trigger[data-wait-loading], .js-fade-in[data-wait-loading]');
        
        pendingElements.forEach(el => {
            const rect = el.getBoundingClientRect();
            const isInView = rect.top < window.innerHeight && rect.bottom > 0;
            
            // 親グループがすでに画面内にある場合も考慮
            const parentGroup = el.closest('.js-scroll-trigger-group');
            const isParentInView = parentGroup && parentGroup.getBoundingClientRect().top < window.innerHeight;

            if (isInView || isParentInView) {
                // activateElement内の条件(isPageLoaded)がtrueになっているため発火する
                // 直接クラス付与でもOK
                if (el.dataset.delay) {
                    el.style.setProperty('--delay', `${el.dataset.delay}s`);
                }
                el.classList.add('is-show');
                observer.unobserve(el);
            }
        });
    });
});


/**
 * 汎用スライドアニメーション（マスク）
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // 1. ターゲットとなる要素をすべて取得
  const revealElements = document.querySelectorAll('.js-reveal-clip');

  if (revealElements.length === 0) return; // 要素がなければ何もしない

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        
        // HTMLの data-delay="0.5" などを取得（数値に変換）
        const delayAttr = el.getAttribute('data-delay');
        const delay = delayAttr ? parseFloat(delayAttr) * 1000 : 0;

        // 指定されたディレイ後に実行
        setTimeout(() => {
          el.classList.add('is-animated');
        }, delay);

        // 一度実行したら監視を解除
        observer.unobserve(el);
      }
    });
  }, {
    // 画面の下端から5%入ったところで発火
    rootMargin: '0px 0px -5% 0px',
    threshold: 0 
  });

  // 2. 各要素の監視を開始
  revealElements.forEach(el => observer.observe(el));
});


/**
 * ノンデザブログ スクロールアニメーション
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.6 // 40%見えたら発火
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-animated');
        // 一度表示されたら監視を解除する場合
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // 全ての blog-item を監視対象にする
  const items = document.querySelectorAll('.blog-item');
  items.forEach(item => observer.observe(item));
});


/**
 * ノンデザブログ ホバーアニメーション
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    const splitTexts = document.querySelectorAll('.js-split-hover');

    splitTexts.forEach((target) => {
        // 現在のテキストを取得（トリミングして余計な改行を除く）
        const originalText = target.textContent.trim();
        target.innerHTML = ''; // 中身をリセット

        // 1文字ずつ配列にしてループ
        originalText.split('').forEach((char, index) => {
            const span = document.createElement('span');
            span.classList.add('anim-char');
            
            // インデックス番号をカスタムプロパティとして付与
            span.style.setProperty('--i', index);
            
            // 空白文字が詰められないように処理
            if (char === ' ') {
                span.innerHTML = '&nbsp;';
            } else {
                span.textContent = char;
            }
            
            target.appendChild(span);
        });
    });
});


/**
 * コピー用リッチスクロールアニメーション
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    
    // 1. 文字を分割して準備する
    const revealTargets = document.querySelectorAll('.js-text-reveal');
    
    revealTargets.forEach(target => {
        const text = target.textContent.trim();
        target.innerHTML = text.split('').map((char, i) => 
            `<span class="char" style="--char-index: ${i}">${char === ' ' ? '&nbsp;' : char}</span>`
        ).join('');
    });

    // 2. スクロールを監視して、画面に入ったら発火させる
    const observerOptions = {
        root: null,
        rootMargin: '0px 0px -10% 0px', // 画面の下から10%入ったら動く
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 画面に入ったら .is-visible を付与
                entry.target.classList.add('is-visible');
                // 一度動いたら監視を解除（1回きりの演出）
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    revealTargets.forEach(el => observer.observe(el));
});


/**
 * 汎用アニメーションスクリプト（拡張版）
 * - [data-reveal]: 単体発火
 * - [data-reveal-group]: 配下の[data-reveal]をまとめて発火
 * - [data-wait-loading]: ロード完了まで待機
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    const targets = document.querySelectorAll('[data-reveal], [data-hover-reveal]');
    let isPageLoaded = false;

    // --- 1. テキスト分解・スタイルセット (初期化) ---
    const processNode = (node, index, baseDelay, stagger) => {
        if (node.nodeType === Node.TEXT_NODE) {
            const chars = node.textContent.split('');
            const fragment = document.createDocumentFragment();
            
            chars.forEach(char => {
                if (char.match(/\s/) && char !== ' ') return;
                const span = document.createElement('span');
                span.className = 'anim-char';
                
                span.style.setProperty('--i', index.val++);
                span.style.setProperty('--base-delay', baseDelay ? `${baseDelay}s` : '0s');
                span.style.setProperty('--stagger', stagger ? `${stagger}s` : '0.01s');
                
                span.innerHTML = char === ' ' ? '&nbsp;' : char;
                fragment.appendChild(span);
            });
            node.parentNode.replaceChild(fragment, node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            Array.from(node.childNodes).forEach(child => processNode(child, index, baseDelay, stagger));
        }
    };

    targets.forEach(target => {
        const baseDelay = target.getAttribute('data-delay');
        const stagger = target.getAttribute('data-stagger');
        const index = { val: 0 }; 
        processNode(target, index, baseDelay, stagger);
    });

    // --- 2. 発火処理の定義 ---
    const activateElement = (el) => {
        // ロード待機属性があり、まだロード未完了ならスキップ
        if (el.hasAttribute('data-wait-loading') && !isPageLoaded) return;
        
        el.setAttribute('data-state', 'active');
        // 個別に監視されている場合に備えて解除
        observer.unobserve(el);
    };

    // --- 3. IntersectionObserverの設定 ---
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const target = entry.target;

                // A. グループ指定がある場合：配下をすべて発火
                if (target.hasAttribute('data-reveal-group')) {
                    const children = target.querySelectorAll('[data-reveal]');
                    children.forEach(child => activateElement(child));
                    observer.unobserve(target);
                } 
                // B. 単体要素の場合（親がグループでない場合のみ直接発火）
                else {
                    if (!target.closest('[data-reveal-group]')) {
                        activateElement(target);
                    }
                }
            }
        });
    }, { 
        threshold: 0.15,
        rootMargin: '0px 0px -5% 0px' // 少し早めに発火させる調整（任意）
    });

    // 監視の開始
    document.querySelectorAll('[data-reveal], [data-reveal-group]').forEach(el => {
        observer.observe(el);
    });

    // --- 4. ロード完了イベント制御 ---
    window.addEventListener('loading-complete', () => {
        isPageLoaded = true;

        // すでに画面内にある待機要素をチェック
        const allPendingItems = document.querySelectorAll('[data-reveal][data-wait-loading]');
        allPendingItems.forEach(item => {
            const rect = item.getBoundingClientRect();
            const isInView = rect.top < window.innerHeight && rect.bottom > 0;
            
            // 画面内にある、または「グループの親」が画面内にあれば発火
            const parentGroup = item.closest('[data-reveal-group]');
            const isParentInView = parentGroup && parentGroup.getBoundingClientRect().top < window.innerHeight;

            if (isInView || isParentInView) {
                activateElement(item);
            }
        });
    });
});


/**
 * TOPコース テキストエリア スクロールアニメーション
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
        root: null,
        rootMargin: '0px 0px -15% 0px', // 少し深め（15%）に入ったら発火
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // .course__content（塊）を監視
    document.querySelectorAll('.course__content').forEach(el => observer.observe(el));
});


/**
 * インタビュー動画 スクロールアニメーション
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    // 親コンテナを監視対象にする
    const container = document.querySelector('.member-result__slider-wrapper');
    const items = document.querySelectorAll('.member-result__item');
    
    if (!container) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // コンテナが画面内に入ったら、全アイテムにクラスを付与
                items.forEach(item => {
                    item.classList.add('is-visible');
                });
                // 一度発火したらコンテナの監視を解除
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.15 // 発火タイミング例）0.2→20%見えたらは発火
    });

    observer.observe(container);
});



/**
 * RECOMMEND 出現アニメーション
 * - PCはreveal-sectionトリガーで４つ均等にディレイ
 * - SPはcard-wrapperトリガーで1つずつアニメーション
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
        threshold: 0.2 // 少し早めに発火するように調整
    };

    // 共通のコールバック関数
    const revealCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                // 一度表示されたら監視を解除（パフォーマンス向上）
                observer.unobserve(entry.target);
            }
        });
    };

    const sectionObserver = new IntersectionObserver(revealCallback, observerOptions);

    const revealSection = document.getElementById('reveal-section');
    const cards = document.querySelectorAll('.card-wrapper');

    // --- ここで分岐処理 ---
    if (window.innerWidth <= 960) {
        // スマホ：各カードを個別に監視
        cards.forEach(card => {
            sectionObserver.observe(card);
        });
    } else {
        // PC：親コンテナを監視（一括発火）
        sectionObserver.observe(revealSection);
    }

    // Not Recommended ボックス用
    const nrBox = document.getElementById('nr-box');
    const boxObserver = new IntersectionObserver(revealCallback, observerOptions);
    if (nrBox) boxObserver.observe(nrBox);
});

/**
 * BONUS特典モーダルカード +アイコン出現アニメーション
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5 // 50%見えたら実行
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // ターゲットにクラスを付与
        entry.target.classList.add('is-active');
        // 一度発火したら監視を解除する場合
        observer.unobserve(entry.target);
      }
    });
  }, options);

  // 全てのプラスアイコンを監視
  const targets = document.querySelectorAll('.modal-card__plus-symbol');
  targets.forEach(target => observer.observe(target));
});


/**
 * セカンドヘッダー挙動
 * - second-header-triggerクラスの要素を過ぎるまでは出現しない（PC/SP）
 * - スクロールを上に戻した時だけ出現（PCのみ）
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', function() {
  const secondHeader = document.querySelector('.second-header');
  const triggerElement = document.querySelector('.second-header-trigger');
  
  // スクロール位置保持用
  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', function() {
    const currentScrollY = window.scrollY;
    const triggerBottom = triggerElement.getBoundingClientRect().bottom;
    const isPastTrigger = triggerBottom < 0; // トリガーを過ぎたか
    const isMobile = window.innerWidth <= 960; // 960px以下判定
    
    let shouldShow = false;

    if (isPastTrigger) {
      if (isMobile) {
        // 960px以下の場合は、トリガーを過ぎていれば常時表示
        shouldShow = true;
      } else {
        // 961px以上の場合は、上にスクロールしている時のみ表示
        // 少しのブレでガタつかないよう 5px 以上の移動を検知
        if (lastScrollY - currentScrollY > 5) {
          shouldShow = true;
        } else if (currentScrollY - lastScrollY > 5) {
          // 下にスクロールした場合は非表示
          shouldShow = false;
        } else {
          // 微細な動きの場合は、現在の表示状態を維持
          shouldShow = secondHeader.classList.contains('is-show');
        }
      }
    } else {
      // トリガーより上の場合は強制非表示
      shouldShow = false;
    }

    // クラスの付け外し
    if (shouldShow) {
      secondHeader.classList.add('is-show');
    } else {
      secondHeader.classList.remove('is-show');
    }

    lastScrollY = currentScrollY;
  }, { passive: true });
});


/**
 * LDTレッスンページ ソースコードコピペ機能
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // LDTのコンテンツが動的に生成される場合を考慮し、少し遅らせるか定期的にチェック
  const initCopyButtons = () => {
    const codeBlocks = document.querySelectorAll('.ck-content pre');

    codeBlocks.forEach((block) => {
      // 既にボタンがある場合はスキップ
      if (block.querySelector('.ldt-copy-button')) return;

      const button = document.createElement('button');
      button.className = 'ldt-copy-button';
      button.innerText = 'Copy';
      button.type = 'button';

      block.appendChild(button);

      button.addEventListener('click', () => {
        // block内のcodeタグ、またはテキストを取得
        const codeElement = block.querySelector('code');
        const textToCopy = codeElement ? codeElement.innerText : block.innerText.replace('Copy', '');

        navigator.clipboard.writeText(textToCopy).then(() => {
          // ボタンの表示を切り替え
          button.innerText = 'Copied!';
          button.classList.add('is-copied');

          // 2秒後に元に戻す
          setTimeout(() => {
            button.innerText = 'Copy';
            button.classList.remove('is-copied');
          }, 2000);
        }).catch(err => {
          console.error('コピーに失敗しました', err);
        });
      });
    });
  };

  // 初回実行
  initCopyButtons();

  // LDTのようなアプリはコンテンツが後から読み込まれることが多いため、
  // 3秒間、1秒ごとに再スキャンする（簡易的な対応）
  let count = 0;
  const timer = setInterval(() => {
    initCopyButtons();
    count++;
    if (count > 3) clearInterval(timer);
  }, 1000);
});


/* ここから下は動画読み込み対策
 -------------------------------------------------------------------*/
/**
 * 動画読み込みの対策（修正版）
 -----------------------------------*/
(() => {
  const videos = document.querySelectorAll('video.js-fv-lazy-video, video.js-lazy-video');
  if (!videos.length) return;

  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  if (reduceMotion) return;

  const isMobileBlocked = (video) => {
    return video.classList.contains('js-responsive-video') && window.innerWidth <= 560;
  };

  const ensureSources = (video) => {
    if (video.dataset.loaded) return;

    video.querySelectorAll('source').forEach(s => {
      const ds = s.getAttribute('data-src');
      if (ds && !s.getAttribute('src')) s.setAttribute('src', ds);
    });

    const vds = video.getAttribute('data-src');
    if (vds && !video.getAttribute('src')) video.setAttribute('src', vds);

    video.load();
    video.dataset.loaded = '1';
  };

  const playSafe = (video) => {
    if (isMobileBlocked(video)) return;
    
    // 【重要】autoplay属性がない動画は、ローディング側で制御するためここでは無視する
    // ただし、既に一度ロード済みの場合はスクロール復帰として再生を許可する
    if (!video.hasAttribute('autoplay') && !video.dataset.loaded) return;

    ensureSources(video);

    if (video.style.display === 'none') video.style.display = '';
    video.play().catch(() => {});
  };

  const pauseSafe = (video) => {
    if (!video.paused) video.pause();
  };

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => playSafe(video), { timeout: 2000 });
          } else {
            setTimeout(() => playSafe(video), 200);
          }
        });
      } else {
        pauseSafe(video);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '200px 0px 200px 0px'
  });

  videos.forEach(v => io.observe(v));

  window.addEventListener('resize', () => {
    videos.forEach(v => {
      if (isMobileBlocked(v)) {
        pauseSafe(v);
        v.style.display = 'none';
      } else {
        v.style.display = '';
        const r = v.getBoundingClientRect();
        const inView = r.bottom > 0 && r.top < window.innerHeight;
        if (inView) playSafe(v);
      }
    });
  }, { passive: true });
})();




/**
 * 制作実績：動画再生ロジック（PCホバー ＆ SP自動再生）
 -----------------------------------*/
const initCustomVideoSystem = () => {
  const isSP = () => window.innerWidth <= 960;
  let currentPlayingContainer = null;

  // --- 動画注入・再生・停止の基本関数 ---
  const injectVideoIfNeeded = (container) => {
    if (!container || container.querySelector('video')) return container.querySelector('video');
    const webm = container.getAttribute('data-video-webm');
    const mp4 = container.getAttribute('data-video-mp4');
    if (!webm && !mp4) return null;

    const video = document.createElement('video');
    video.muted = true;
    video.playsInline = true;
    // JSで制御するため、HTML属性としてのloopはオフにする
    video.loop = false; 
    video.classList.add('js-injected-video');
    video.setAttribute('preload', 'metadata'); 
    
    if (webm) { const s = document.createElement('source'); s.src = webm; s.type = "video/webm"; video.appendChild(s); }
    if (mp4) { const s = document.createElement('source'); s.src = mp4; s.type = "video/mp4"; video.appendChild(s); }
    
    // 動画終了時のイベントリスナーを追加
    video.addEventListener('ended', () => {
      // 1. フェードで画像に戻す
      pauseVideo(container);
      
      // 2. 少し余韻を置いてから再再生（0.5秒など。即時なら0）
      setTimeout(() => {
        // コンテナがまだホバー中、またはSPでアクティブなら再再生
        const isHover = container.closest('.works-card__link:hover');
        if (isHover || (isSP() && currentPlayingContainer === container)) {
          playVideo(container);
        }
      }, 600); // フェードの時間に合わせて調整
    });

    container.appendChild(video);
    return video;
  };

  const playVideo = (container) => {
    const video = injectVideoIfNeeded(container);
    if (!video) return;
    const poster = container.querySelector('.js-video-poster') || container.querySelector('img:not(.js-injected-video)');
    
    video.currentTime = 0; // 必ず最初から再生
    video.play().then(() => {
      video.style.opacity = "1";
      if (poster) poster.style.opacity = "0";
    }).catch(() => {});
  };

  const pauseVideo = (container) => {
    const video = container.querySelector('video');
    const poster = container.querySelector('.js-video-poster') || container.querySelector('img:not(.js-injected-video)');
    if (!video) return;
    video.style.opacity = "0";
    if (poster) poster.style.opacity = "1";
    // 完全に消えてから一時停止
    setTimeout(() => { if(video.paused === false) video.pause(); }, 400);
  };

  // PC用：ホバー再生
  document.querySelectorAll('.works-card__link').forEach(trigger => {
    const container = trigger.querySelector('.js-video-container');
    if (!container) return;
    trigger.addEventListener('mouseenter', () => { if (!isSP()) playVideo(container); });
    trigger.addEventListener('mouseleave', () => {
      if (!isSP()) {
        pauseVideo(container);
      }
    });
  });

  // SP用：画面中央優先
  const spAutoPlayObserver = new IntersectionObserver((entries) => {
    if (!isSP()) return;
    entries.forEach(entry => {
      const container = entry.target.querySelector('.js-video-container');
      if (!container) return;
      if (entry.isIntersecting) {
        if (currentPlayingContainer && currentPlayingContainer !== container) pauseVideo(currentPlayingContainer);
        playVideo(container);
        currentPlayingContainer = container;
      } else {
        if (currentPlayingContainer === container) {
          pauseVideo(container);
          currentPlayingContainer = null;
        }
      }
    });
  }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

  document.querySelectorAll('.js-works-card').forEach(card => spAutoPlayObserver.observe(card));
};

document.addEventListener('DOMContentLoaded', initCustomVideoSystem);
document.addEventListener('shopify:section:load', initCustomVideoSystem);



/**
 * 制作実績詳細ページ専用：js-single-video-container 再生ロジック
 * 動画終了後にフェードで画像に戻り、ループ再生する修正版
 -----------------------------------*/
const initSingleVideoAutoPlay = () => {
  const containers = document.querySelectorAll('.js-single-video-container');
  
  if (!containers.length) return;

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1 // 10%見えたら再生開始
  };

  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const container = entry.target;
      let video = container.querySelector('video');
      const posterImg = container.querySelector('.js-video-poster, img');
      
      if (entry.isIntersecting) {
        // --- 動画の注入 ---
        if (!video) {
          const webm = container.getAttribute('data-video-webm');
          const mp4 = container.getAttribute('data-video-mp4');
          const poster = container.getAttribute('data-poster');

          if (!webm && !mp4) return;

          video = document.createElement('video');
          video.muted = true;
          video.playsInline = true;
          video.loop = false; // 自動ループはオフ（手動で制御）
          video.setAttribute('preload', 'metadata');
          if (poster) video.setAttribute('poster', poster);
          
          video.style.opacity = "0";
          video.style.transition = "opacity 0.8s ease";
          video.style.width = "100%";
          video.style.height = "100%";
          video.style.objectFit = "cover";

          // 動画終了時の処理
          video.addEventListener('ended', () => {
            // 1. 動画をフェードアウトさせて画像を表示
            video.style.opacity = "0";
            if (posterImg) posterImg.style.opacity = "1";
            
            // 2. 0.8秒（transition分）待ってから再スタート
            setTimeout(() => {
              // まだ画面内にいる場合のみ再開
              if (container.getAttribute('data-is-intersecting') === 'true') {
                video.currentTime = 0;
                video.play().then(() => {
                  video.style.opacity = "1";
                  if (posterImg) posterImg.style.opacity = "0";
                });
              }
            }, 1000); // 1.0秒程度の間隔
          });

          if (webm) {
            const s = document.createElement('source'); s.src = webm; s.type = "video/webm"; video.appendChild(s);
          }
          if (mp4) {
            const s = document.createElement('source'); s.src = mp4; s.type = "video/mp4"; video.appendChild(s);
          }
          
          container.appendChild(video);
        }

        // --- 再生開始 ---
        container.setAttribute('data-is-intersecting', 'true');
        video.play().then(() => {
          video.style.opacity = "1";
          if (posterImg) posterImg.style.opacity = "0";
        }).catch(err => console.log("Auto-play blocked:", err));

      } else {
        // --- 画面外に出たら停止 ---
        container.setAttribute('data-is-intersecting', 'false');
        if (video) {
          video.pause();
          video.style.opacity = "0";
          if (posterImg) posterImg.style.opacity = "1";
        }
      }
    });
  }, observerOptions);

  containers.forEach(el => videoObserver.observe(el));
};

// 実行（DOMContentLoaded等）
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSingleVideoAutoPlay);
} else {
  initSingleVideoAutoPlay();
}
document.addEventListener('shopify:section:load', initSingleVideoAutoPlay);



/**
 * モーダル専用ビデオ制御
 * 既存の自動再生ロジックとは完全に独立して動作します
 */
const initModalVideoController = () => {
  const modalRoots = document.querySelectorAll('.js-works-modal');

  modalRoots.forEach(modal => {
    const container = modal.querySelector('.js-modal-video-only');
    if (!container) return;

    // --- ビデオ生成・再生関数 ---
    const playVideo = () => {
      let video = container.querySelector('video');
      const posterImg = container.querySelector('.js-video-poster, img');

      if (!video) {
        const webm = container.getAttribute('data-video-webm');
        const mp4 = container.getAttribute('data-video-mp4');
        const poster = container.getAttribute('data-poster');

        video = document.createElement('video');
        video.muted = true;
        video.playsInline = true;
        video.loop = true; // モーダル内はループ再生
        video.setAttribute('preload', 'auto');
        if (poster) video.setAttribute('poster', poster);
        
        video.style.width = "100%";
        video.style.height = "100%";
        video.style.objectFit = "cover";
        video.style.opacity = "0";
        video.style.transition = "opacity 0.8s ease";

        if (webm) {
          const s = document.createElement('source'); s.src = webm; s.type = "video/webm"; video.appendChild(s);
        }
        if (mp4) {
          const s = document.createElement('source'); s.src = mp4; s.type = "video/mp4"; video.appendChild(s);
        }
        container.appendChild(video);
      }

      // 再生開始
      video.currentTime = 0;
      video.play().then(() => {
        video.style.opacity = "1";
        if (posterImg) posterImg.style.opacity = "0";
      }).catch(e => console.error("Playback failed:", e));
    };

    // --- ビデオ停止関数 ---
    const stopVideo = () => {
      const video = container.querySelector('video');
      const posterImg = container.querySelector('.js-video-poster, img');
      if (video) {
        video.pause();
        video.style.opacity = "0";
        if (posterImg) posterImg.style.opacity = "1";
      }
    };

    // --- モーダルの状態を監視 (MutationObserver) ---
    // classやaria-hiddenの変化を検知して再生/停止を切り替える
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // モーダルが表示状態（クラスにis-activeがつく、またはaria-hiddenがfalseになる等）を判定
        // あなたのサイトのモーダル開閉ロジックに合わせてここを調整してください
        const isVisible = modal.classList.contains('is-active') || modal.style.display === 'block' || modal.getAttribute('aria-hidden') === 'false';
        
        if (isVisible) {
          playVideo();
        } else {
          stopVideo();
        }
      });
    });

    observer.observe(modal, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });

    // 念のため閉じるボタンにも停止処理を紐付け
    const closeBtns = modal.querySelectorAll('.js-works-modal-close');
    closeBtns.forEach(btn => btn.addEventListener('click', stopVideo));
  });
};

// 実行
document.addEventListener('DOMContentLoaded', initModalVideoController);
if (window.Shopify) {
  document.addEventListener('shopify:section:load', initModalVideoController);
}


/**
 * 以下削除して良いJS
 ---------------------------------------------------------------------------------*/

/**
 * 運営メンバー画像アニメーション
 -----------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const isMobile = window.innerWidth <= 960;

  // --- 遅延設定を一括管理 ---
  const CONFIG = {
    pc: {
      baseDelay: 500,      // 画面に入ってから最初の1枚目が動き出すまでの時間
      staggerDelay: 100    // 2枚目、3枚目とズラしていく間隔（75msから150msに広げて負荷分散）
    },
    mobile: {
      baseDelay: 200       // スマホで各要素が画面に入ってから動き出すまでの時間
    }
  };

  const options = {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: isMobile ? 0.4 : 0.4
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (isMobile) {
          /* --- スマホ：単体発火 --- */
          const cardImg = entry.target.querySelector('.member-card__image');
          if (cardImg) {
            // JS側で設定した固定の遅延を適用
            setTimeout(() => {
              cardImg.classList.add('is-animated');
            }, CONFIG.mobile.baseDelay);
          }
        } else {
          /* --- PC：連鎖（スタッガー）発火 --- */
          const cards = entry.target.querySelectorAll('.member-card__image');
          cards.forEach((card, index) => {
            // インデックスに応じて遅延を計算： 600 + (0*150), 600 + (1*150)...
            const totalDelay = CONFIG.pc.baseDelay + (index * CONFIG.pc.staggerDelay);
            
            setTimeout(() => {
              card.classList.add('is-animated');
            }, totalDelay);
          });
        }
        observer.unobserve(entry.target);
      }
    });
  }, options);

  // 監視対象の設定
  if (isMobile) {
    document.querySelectorAll('.company-intro__item').forEach(item => observer.observe(item));
  } else {
    const container = document.querySelector('.company-intro__right');
    if (container) observer.observe(container);
  }
});
